import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { AIPrimaryButton } from "./AIPrimaryButton";
import { SendIcon } from "../../icons";
// @ts-ignore
import logoImage from "../../../assets/logo.png";
const TextInput = ({ value, onChange, onSubmit, placeholder = "Type your message...", disabled = false, customIcon, noBorder = false, bgColor = 'bg-white', compact = false, }) => {
    const textareaRef = useRef(null);
    // Auto-resize textarea
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 120)}px`;
        }
    }, [value]);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && value.trim()) {
            e.preventDefault();
            onSubmit();
        }
    };
    return (_jsxs("div", { className: `flex items-start gap-2 ${compact ? 'p-2' : 'p-3'} rounded-lg ${noBorder ? '' : 'border border-gray-300 focus-within:border-primary-purple-20 focus-within:shadow-[0_0_6px_-4px_rgba(0,0,0,0.10),0_4px_4px_0_rgba(0,0,0,0.06),0_0_2px_0_rgba(0,0,0,0.06),0_0_1px_0_rgba(0,0,0,0.04)]'} ${bgColor} transition-all`, children: [customIcon ? (_jsx("div", { className: "shrink-0 flex items-center justify-center", style: { width: '24px', height: '24px' }, children: customIcon })) : (_jsx("div", { className: "shrink-0", style: {
                    width: '24px',
                    height: '24px',
                    background: `url(${logoImage}) 50% / cover no-repeat`,
                } })), _jsx("textarea", { ref: textareaRef, value: value, onChange: (e) => onChange(e.target.value), onKeyDown: handleKeyDown, placeholder: placeholder, disabled: disabled, rows: 1, className: "flex-1 text-sm text-gray-990 placeholder-gray-400 outline-none bg-transparent resize-none min-h-[24px] max-h-[120px] overflow-y-auto" }), _jsx("div", { className: "self-end", children: _jsx(AIPrimaryButton, { onClick: onSubmit, disabled: !value.trim() || disabled, icon: _jsx(SendIcon, { size: 24, color: "white" }) }) })] }));
};
export default TextInput;
